import { render, staticRenderFns } from "./FlameGraph.vue?vue&type=template&id=78bd9286&scoped=true"
import script from "./FlameGraph.vue?vue&type=script&lang=js"
export * from "./FlameGraph.vue?vue&type=script&lang=js"
import style0 from "./FlameGraph.vue?vue&type=style&index=0&id=78bd9286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd9286",
  null
  
)

export default component.exports